import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { heightRestrictionConfig } from "../../services/OgcService/HeightRestrictionService";
import { trafficMessageConfig } from "../../services/OgcService/TrafficMessageService";
import { OpenAPI } from "../../services/RuteplanAPI";
import { EnvironmentName, IEnvironmentSetting, useEnvironmentName, useEnvironmentSetting, useEnvironmentSettingActions } from "../../stores/EnvironmenSettingStore";

function getActiveButtonIndex(environmentName: EnvironmentName): number {

    switch (environmentName) {
        case "prod":
            return 0;
        case "atm":
            return 1;
        case "stm":
            return 2;
        case "local":
            return 3;
        default:
            return 0;
    }
}

export function EnvironmentSelector(){    
    const environmentName = useEnvironmentName();
    const {setEnvironment} = useEnvironmentSettingActions();
    const [activeButtonIndex, setActiveButtonIndex] = React.useState(getActiveButtonIndex(environmentName));

    useEffect( () => {
        setActiveButtonIndex(getActiveButtonIndex(environmentName))   
    }, [environmentName])

    function getVariant(buttonIndex: number){
        if(buttonIndex == activeButtonIndex){
            return 'contained'
        }

        return 'text'
    }

    function handleClick(environmentName: EnvironmentName, buttonIndex: number){
        setActiveButtonIndex(buttonIndex);
        setEnvironment(environmentName);
    }

    return(
        <div>
            <Button size="small" variant={getVariant(0)} onClick={() => handleClick("prod", 0)}>PROD</Button>
            <Button size="small" variant={getVariant(1)} onClick={() => handleClick("atm", 1)}>ATM</Button>
            <Button size="small" variant={getVariant(2)} onClick={() => handleClick("stm", 2)}>STM</Button>
            <Button size="small" variant={getVariant(3)} onClick={() => handleClick("local", 3)}>LOKALT</Button>
        </div>
    )
}